/* One pass of a Kawase blur, for a quad mesh. Same math as @pixi/filter-kawase-blur, which only works as a filter */
export default `
precision highp float;
varying vec2 vUv;

uniform sampler2D texture;
uniform vec2 uOffset;

void main() {
	vec4 color = texture2D(texture, vec2(vUv.x - uOffset.x, vUv.y + uOffset.y));
	color += texture2D(texture, vec2(vUv.x + uOffset.x, vUv.y + uOffset.y));
	color += texture2D(texture, vec2(vUv.x + uOffset.x, vUv.y - uOffset.y));
	color += texture2D(texture, vec2(vUv.x - uOffset.x, vUv.y - uOffset.y));
	gl_FragColor = color * 0.25;
}`;
